import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import { Share2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
/**
 * Marks a study the user can read only because another clinic shared it with
 * theirs ("Shared from {owner}"). Renders nothing for an owned study, so call
 * sites pass `study.accessVia` unconditionally.
 *
 * The tooltip carries the one rule that matters: view and download work, edits
 * do not. Deliberately neutral (muted pill, no alarm colour) — it is a fact
 * about the study, not a warning.
 */
export function SharedFromBadge({ accessVia, className, testId, }) {
    const { t } = useTranslation();
    if (!accessVia)
        return null;
    const label = accessVia.sharedFromName
        ? t('sharedStudy.badge', { clinic: accessVia.sharedFromName })
        : t('sharedStudy.badgeUnnamed');
    const tooltip = t('sharedStudy.tooltip');
    return (_jsxs("span", { "data-testid": testId ?? 'shared-from-badge', title: tooltip, "aria-label": `${label}. ${tooltip}`, className: cn('bg-muted text-muted-foreground inline-flex max-w-[14rem] min-w-0 shrink-0 items-center gap-1 rounded px-1.5 py-px text-[10px] leading-4 font-medium normal-case', className), children: [_jsx(Share2, { className: "h-2.5 w-2.5 shrink-0", "aria-hidden": true }), _jsx("span", { className: "truncate", children: label })] }));
}
